module.exports = __webpack_public_path__ + "static/media/info_icon_fisdom.27064b13.svg";